import { Typography } from "antd";

const CaptionText = ({ caption, textValue }) => (
  <div style={{ marginBottom: '16px', lineHeight: 1.0 }}>
    <Typography.Text strong style={{ fontSize: '12px', color: 'gray' }}>{caption}</Typography.Text>
    <br />
    <Typography.Text>{textValue}</Typography.Text>
    <br />
  </div>
);

export default CaptionText;
